var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[(_vm.loading)?_c('b-spinner',{attrs:{"variant":"primary"}}):_c('div',[_c('h6',{staticClass:"mb-5"},[_vm._v("Comissões")]),_c('h5',{staticClass:"text-dark"},[_vm._v(" - ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }